export function FeatureToolsIllustration({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 320 180" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="320" height="180" fill="#faf9f6" />
      
      {/* Network lines */}
      <g stroke="#111111" strokeWidth="1.5" strokeDasharray="3 4" fill="none" opacity="0.4">
        <path d="M 160 90 L 80 50" />
        <path d="M 160 90 L 240 50" />
        <path d="M 160 90 L 80 130" />
        <path d="M 160 90 L 240 130" />
      </g>
      
      {/* Peripheral nodes */}
      {[[80, 50], [240, 50], [80, 130], [240, 130]].map(([x, y], i) => (
        <g key={i} transform={`translate(${x} ${y})`}>
          {/* Shadow element */}
          <rect x="-22" y="-22" width="48" height="48" rx="8" fill="none" stroke="#111111" strokeWidth="1.5" opacity="0.2" />
          <rect x="-24" y="-24" width="48" height="48" rx="8" fill="#ffffff" stroke="#111111" strokeWidth="1.5" />
          
          {/* Abstract tool shapes */}
          {i === 0 && <circle cx="0" cy="0" r="8" fill="#111111" />}
          {i === 1 && <rect x="-6" y="-6" width="12" height="12" fill="none" stroke="#111111" strokeWidth="2" />}
          {i === 2 && <path d="M-8 -4 L8 4 L-8 4 L8 -4" stroke="#111111" strokeWidth="2" strokeLinejoin="round" fill="none" />}
          {i === 3 && <path d="M-6 -6 L0 6 L6 -6 Z" fill="#111111" />}
        </g>
      ))}

      {/* Central AI node */}
      <g transform="translate(160 90)">
        <rect x="-26" y="-26" width="56" height="56" rx="12" fill="none" stroke="#111111" strokeWidth="1.5" opacity="0.2" />
        <rect x="-28" y="-28" width="56" height="56" rx="12" fill="#111111" />
        <circle cx="0" cy="0" r="12" fill="#ff5600" />
        <path d="M0 -5 L0 5 M-5 0 L5 0" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" />
      </g>
    </svg>
  );
}
